import React from 'react';
import './cta.scss';
import image from '../../assets/cta.jpg';
import imageM from '../../assets/ctaM.png';

function CTA({ width }) {
  return (
    <section className="cta">
      <img src={width > 480 ? image : imageM} alt="" className="cta__image" />
      <div className="cta__text">
        <h3 className="cta__text--title">The CAR T Together Initiative</h3>
        <p className="cta__text--copy">
          CAR T Together™ is a first-of-its-kind initiative that brings together oncologists from
          preeminent research institutions to harness the spirit of cooperation needed to make the
          next revolution for cell therapy a reality—potentially turning the promise of scalable,
          off-the-shelf (allogeneic) CAR T products into a reality and expanding access to cancer
          patients.
        </p>
        <a
          href="https://carttogether.com/?utm_source=CNN&utm_medium=LinkedIn&utm_campaign=CARTTogether+"
          className="cta__link"
          target='_blank' rel="sponsored noopener"
        >
          <div className="cta__button">
            <span className="cta__button__copy">
              For more information, visit www.CARTTogether.com
            </span>
            <svg
              width="22"
              height="18"
              viewBox="0 0 22 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cta__button__arrow"
            >
              <path
                d="M21.4054 8.7535L20.2566 7.54994L13.254 0.197266L10.7266 2.60439L14.9171 7.00287H0.780762V10.5041H14.9171L10.7266 14.9026L13.254 17.3097L20.2566 9.95707L21.4054 8.7535Z"
                className="cta__button__arrow-path"
              />
            </svg>
          </div>
        </a>
      </div>
    </section>
  );
}

export default CTA;
